import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { ArrowRight } from "lucide-react";

const QRLanding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [roomInput, setRoomInput] = useState("");
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const roomNumber = searchParams.get("room");
    if (roomNumber) {
      // In-room QR: set source and redirect
      sessionStorage.setItem("order_source", "in_room");
      navigate(`/room/${roomNumber}`, { replace: true });
    } else {
      setShowFallback(true);
    }
  }, [searchParams, navigate]);

  const handleGo = () => {
    const r = roomInput.trim();
    if (r) {
      sessionStorage.setItem("order_source", "in_room");
      navigate(`/room/${r}`);
    }
  };

  if (!showFallback) {
    return <div className="min-h-screen bg-[#1c3b2e]" />;
  }

  return (
    <div className="min-h-screen bg-[#1c3b2e] flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-6 pt-16 pb-8">
        <div className="text-center space-y-3 mb-10">
          <h1 className="text-5xl font-bold text-white tracking-tight">VOW</h1>
          <p className="text-sm font-medium tracking-[0.2em] text-[#bd9b5e] uppercase">Voyage of Wellness</p>
        </div>
        <div className="w-16 h-px bg-[#bd9b5e]/40 mb-10"></div>
        <div className="text-center max-w-xs">
          <h2 className="text-xl font-semibold text-white mb-2">In-Room Dining</h2>
          <p className="text-sm text-white/60 leading-relaxed">
            Scan the QR code in your room to browse our menu and place an order
          </p>
        </div>
      </div>

      <div className="bg-[#f5f1e6] rounded-t-3xl px-6 pt-8 pb-10">
        <p className="text-sm font-medium text-[#2c2c2c] mb-4 text-center">
          Or enter your room number
        </p>
        <div className="flex gap-3 max-w-xs mx-auto">
          <Input
            type="text"
            placeholder="Room No."
            value={roomInput}
            onChange={e => setRoomInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleGo()}
            className="flex-1 h-12 rounded-xl bg-white border-[#1c3b2e]/10 text-center text-lg font-semibold placeholder:text-[#2c2c2c]/30 focus-visible:ring-[#1c3b2e]"
            data-testid="room-number-input"
          />
          <button
            onClick={handleGo}
            disabled={!roomInput.trim()}
            className="h-12 w-12 rounded-xl bg-[#1c3b2e] text-white flex items-center justify-center hover:bg-[#1c3b2e]/90 disabled:opacity-30 transition-colors min-h-[44px]"
            data-testid="go-button"
          >
            <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRLanding;
